
import AdsApi from '../libs/ads-request/ads-api';
import orderDetail from '../libs/mixins/orderDetail';
import LOGIN_CONSTANTS from '../store/login-constants';

export default {
  name: 'LoginGrp',

  mixins: [orderDetail],

  data: () => ({
    isError: false,
    isInterno: false,
    showTutorial: false,
  }),

  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },

  async mounted() {
    this.loaderShow('Iniciando sesión');

    if (this.$route.query.email && this.$route.query.orderId) {
      this.login();
    } else {
      this.isInterno = true;
    }
  },

  methods: {
    login() {
      const { email } = this.$route.query;
      const { orderId } = this.$route.query;
      const { userInternalId } = this.$route.query;
      const { token } = this.$route.query;

      const sessionTimeoutMs = 3600000;

      if (this.$session.exists()) this.$session.destroy();
      if ('superOrderId' in localStorage) localStorage.removeItem('superOrderId');
      if ('isInternal' in localStorage) localStorage.removeItem('isInternal');

      // this.$session.start(60000); //2 min
      this.$session.start(sessionTimeoutMs);

      // Guardamos en el localStorage si entro un interno a la vista del cliente
      localStorage.setItem('isInternal', '1');
      localStorage.setItem('superOrderId', this.$route.query.orderId);
      this.$session.set('superOrderId', this.$route.query.orderId);
      localStorage.setItem('originAuth', true);
      this.$session.set('token', token);
      localStorage.setItem('token', token);

      AdsApi.orderDetail(email, orderId, userInternalId)
        .then((res) => {
          const { success, data, message } = res;

          const brand = this.$session.get('brand') && this.$session.get('brand') !== ''
            ? this.$session.get('brand')
            : process.env.VUE_APP_BRAND;

          if (!success) throw new Error(`[${message}] ${LOGIN_CONSTANTS.ERROR}`);

          this.getDataAdviser(data.orders);
          this.$session.set('brand', brand);
          this.$session.set('email', email);
          this.$session.set('isInternal', true);
          this.$session.set('token', token);
          this.$session.set('userInternalId', userInternalId);
          this.setOrderDetailSession(data);

          // Seteamos el theme de la marca
          this.$store.commit('SET_LAYOUT', `${brand[0].toUpperCase()}${brand.substring(1)}Layout`);
          this.$router.push({ name: 'home' });
        })
        .catch((error) => {
          this.isError = true;
          throw error;
        })
        .finally(() => this.loaderHide());
    },
  },
};
